"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionButton = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Button = require("../Button");
var _ButtonDropdown = require("../ButtonDropdown");
var _ConditionalWrapper = require("../ConditionalWrapper");
var _Tooltip = require("../Tooltip");
var _OptionButtonModule = _interopRequireDefault(require("./OptionButton.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const OptionButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    iconLeftName,
    iconLeftType,
    type,
    isFluid,
    disabled,
    size,
    isLoading,
    menu,
    anchorPosition,
    onOptionSelect,
    onButtonClick,
    onMenuOpen,
    onMenuClose,
    ariaLabel,
    actionType,
    tooltip,
    classNames,
    clickAwayRef
  } = _ref;
  const [iconName, setIconName] = React.useState('chevron-down');
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_OptionButtonModule.default.container, {
      [_OptionButtonModule.default.isFluid]: isFluid
    }, classNames?.wrapper),
    ref: ref
  }, /*#__PURE__*/React.createElement(_ConditionalWrapper.ConditionalWrapper, {
    condition: Boolean(tooltip?.baseButton),
    wrapper: children => /*#__PURE__*/React.createElement(_Tooltip.Tooltip, _extends({}, tooltip?.baseButton, {
      hidden: isMenuOpen ? true : tooltip?.optionsButton?.hidden
    }), children)
  }, /*#__PURE__*/React.createElement(_Button.Button, {
    iconLeftName: iconLeftName,
    iconLeftType: iconLeftType,
    onClick: onButtonClick,
    size: size,
    type: type,
    disabled: disabled,
    isFluid: isFluid,
    ariaLabel: ariaLabel,
    actionType: actionType,
    isLoading: isLoading,
    classNames: {
      wrapper: (0, _classify.default)(_OptionButtonModule.default.leftButton, classNames?.baseButtonWrapper),
      icon: classNames?.baseButtonIcon
    }
  }, children)), /*#__PURE__*/React.createElement(_ButtonDropdown.ButtonDropdown, {
    anchorPosition: anchorPosition,
    ariaLabel: ariaLabel,
    iconLeftName: iconName,
    tooltip: tooltip?.optionsButton,
    classNames: {
      buttonWrapper: (0, _classify.default)(_OptionButtonModule.default.rightButton, classNames?.optionsButtonWrapper),
      dropdownContainer: (0, _classify.default)(_OptionButtonModule.default.dropDownContainer, classNames?.dropdownContainer),
      buttonIcon: classNames?.optionsButtonIcon
    },
    type: type,
    disabled: disabled,
    menu: menu,
    onMenuClose: () => {
      setIconName('chevron-down');
      setIsMenuOpen(false);
      onMenuOpen && onMenuOpen();
    },
    onMenuOpen: () => {
      setIconName('chevron-up');
      setIsMenuOpen(true);
      onMenuClose && onMenuClose();
    },
    onOptionSelect: onOptionSelect,
    size: size,
    clickAwayRef: clickAwayRef
  }));
});
exports.OptionButton = OptionButton;